module.exports = __webpack_public_path__ + "img/file_header.e461ba1b.svg";